import { jsx as _jsx } from "react/jsx-runtime";
import { InfoPill } from '../../../../elementals';
import { ColorNames } from '../../../../../constants';
import { formatMoney } from '../../../../../utils/formatters';
import { acceptedOffer } from '../utils';
const BidRankDistancePill = ({ isBuyer, bidRank, isMobile, compact = false, }) => {
    const overTakeDelta = isBuyer
        ? bidRank?.overtake_delta
        : bidRank?.net_offer_equal_delta;
    if (bidRank?.rank === 1 || !overTakeDelta || acceptedOffer(bidRank))
        return null;
    return (_jsx(InfoPill, { size: 'medium', backgroundColor: ColorNames.CautionLight, foregroundColor: ColorNames.Caution, includeBorder: true, iconName: overTakeDelta >= 1 ? 'arrow-down' : undefined, extraPadding: isMobile ? 'small' : 'medium', content: `
            ${overTakeDelta >= 1 ? formatMoney(overTakeDelta) : '< $1'}${!compact ? ' From 1st Place' : ''}` }));
};
export default BidRankDistancePill;
//# sourceMappingURL=index.js.map